<script>
export default {
    name: "ApprovedJournals",

    props: {

        journals: Array,
    },
    methods:{
fetchSupplierGrn() {
            this.filter.SearchOnly=false;
           
            let url = `SupplierGRN/GetPostedSupplierGoodsReturnNotes`;
                url +=`?SupplierId=${this.filter.supplierId}`;
                url +=`&DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url +=this.filter.search ? `&SearchField=${this.filter.search}` : ``;
                url +=`&SearchOnly=${this.filter.SearchOnly}`;
               return this.$http.get(url).then(({ data }) => {
                this.grnLines = data;
            }).catch(() => {});
        },
          fetchSupplierGrnSearchOnly() {
            this.filter.SearchOnly=true;
            let url = `SupplierGRN/GetPostedSupplierGoodsReturnNotes`;
                url +=`?SupplierId=${this.filter.supplierId}`;
                url +=`&DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url +=this.filter.search ?`&SearchField=${this.filter.search}` : ``;
                url +=`&SearchOnly=${this.filter.SearchOnly}`;
                 return this.$http.get(url).then(({ data }) => {
                this.grnLines = data;
            }).catch(() => {});
        },
          fetchSuppliers() {
            let url = `Shared/GetSuppliers`;

            return this.$http.get(url).then(({ data }) => {
                this.suppliers = data;
            }).catch(() => {});
        }
    },
}
</script>
<template>
    <div class="w-full overflow-auto mt-px">
        <table class="table table-hover">
            <thead class="bg-blue-500 text-white text-xs">
                <tr class="w-full flex">
                    <th class="w-1/6 p-tiny">Supplier</th>
                    <th class="w-1/6 p-tiny">Txn Date</th>
                    <th class="w-1/6 p-tiny">Category</th>
                    <th class="w-1/6 p-tiny">Ref</th>
                    <th class="w-1/6 p-tiny">Memo</th>
                    <th class="w-1/6 p-tiny">User</th>
                    <th class="w-1/12 p-tiny">Ex. Rate</th>
                    <th class="w-1/12 p-tiny">Tax</th>
                    <th class="w-1/12 p-tiny">Amount</th>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                <tr class="flex w-full" v-for="(journal, idx) in journals" :key="idx">
                    <td class="w-1/6 p-tiny">{{ journal.supplier }}</td>
                    <td class="w-1/6 p-tiny">{{ journal.txnDate | dateFormat }}</td>
                    <td class="w-1/6 p-tiny">{{ journal.category }}</td>
                    <td class="w-1/6 p-tiny">{{ journal.ref || `-` }}</td>
                    <td class="w-1/6 p-tiny">{{ journal.memo || `-` }}</td>
                    <td class="w-1/6 p-tiny">{{ journal.userName }}</td>
                    <td class="w-1/12 p-tiny">{{ journal.exchangeRate | numberFormat }}</td>
                    <td class="w-1/12 p-tiny">{{ journal.tax | numberFormat }}</td>
                    <td class="w-1/12 p-tiny">{{ journal.journalAmount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>